(function ($) {
	$.fn.numberstyle = function (options) {
		/*
		 * Default settings
		 */
		var settings = $.extend(
			{
				value: 0,
				step: undefined,
				min: undefined,
				max: undefined,
			},
			options
		);

		/*
		 * Init every element
		 */
		return this.each(function (i) {
			/*
			 * Base options
			 */
			var input = $(this);

			/*
			 * Add new DOM
			 */
			var container = document.createElement("div"),
				btnAdd = document.createElement("div"),
				btnRem = document.createElement("div"),
				min = settings.min ? settings.min : input.attr("min"),
				max = settings.max ? settings.max : input.attr("max"),
				value = settings.value ? settings.value : parseFloat(input.val());
			container.className = "custom-number-input__qty";
			btnAdd.className = max && value >= max ? "custom-number-input__qty-btn custom-number-input__qty-btn--add disabled" : "custom-number-input__qty-btn custom-number-input__qty-btn--add";
			btnAdd.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5935 7.76544L6.15688 3.00771L1.39915 7.44437L0.0488594 5.99636L6.2546 0.209413L12.0415 6.41516L10.5935 7.76544Z" fill="currentColor"/></svg>';
			btnRem.className = min && value <= min ? "custom-number-input__qty-btn custom-number-input__qty-btn--rem disabled" : "custom-number-input__qty-btn custom-number-input__qty-btn--rem";
			btnRem.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5935 0.863464L6.15688 5.6212L1.39915 1.18454L0.0488592 2.63255L6.2546 8.41949L12.0415 2.21375L10.5935 0.863464Z" fill="currentColor"/></svg>';
			input.wrap(container);
			input.closest(".custom-number-input__qty").prepend(btnAdd).append(btnRem);

			// Add new function to calculate and set padding
			function updateInputPadding() {
				var $inputWithSign = input.closest(".ulmc-input__with-sign");
				if ($inputWithSign.length) {
					var $placeholder = $inputWithSign.find(".ulmc-input__text-placeholder");
					var placeholderWidth = $placeholder.outerWidth();
					input.css("padding-left", placeholderWidth + 13 + "px");
				}
			}

			// Call the function initially
			updateInputPadding();

			// Update padding on window resize
			$(window).on("resize", updateInputPadding);

			/*
			 * Attach events
			 */
			$(document)
				.off("mousedown", ".custom-number-input__qty-btn")
				.on("mousedown", ".custom-number-input__qty-btn", function (e) {
					e.preventDefault();
					var $this = $(this);
					var input = $this.siblings("input");
					var step = settings.step ? parseFloat(settings.step) : parseFloat(input.attr("step")) || 0.01;
					var min = settings.min ? parseFloat(settings.min) : input.attr("min") ? parseFloat(input.attr("min")) : undefined;
					var max = settings.max ? parseFloat(settings.max) : input.attr("max") ? parseFloat(input.attr("max")) : undefined;
					var interval;
					var timeout;
					var hasChanged = false;

					$this.addClass("clicked");

					function changeValue() {
						var oldValue = parseFloat(input.val());
						var newVal;

						if ($this.hasClass("custom-number-input__qty-btn--add")) {
							newVal = oldValue + step;
							if (max !== undefined && newVal > max) {
								newVal = max;
							}
						} else {
							newVal = oldValue - step;
							if (min !== undefined && newVal < min) {
								newVal = min;
							}
						}

						newVal = parseFloat(newVal.toFixed(2)); // Limit to 2 decimal places
						input.val(newVal).trigger("change");
						updateButtonStates();
						hasChanged = true;
					}

					timeout = setTimeout(function () {
						changeValue();
						interval = setInterval(changeValue, 200);
					}, 600);

					function handleRelease() {
						clearTimeout(timeout);
						clearInterval(interval);
						$this.removeClass("clicked");
						if (!hasChanged) {
							changeValue();
						}
						$(document).off("mouseup mouseleave", handleRelease);
					}

					$(document).on("mouseup mouseleave", handleRelease);
				});

			input.on("change", function () {
				const val = parseFloat(input.val());

				if (max !== undefined && val > max) {
					input.val(max);
				}

				if (min !== undefined && val < min) {
					input.val(min);
				}

				updateButtonStates();
				updateInputPadding(); // Add this line to update padding on value change
			});

			function updateButtonStates() {
				var value = parseFloat(input.val());
				var $addBtn = input.siblings(".custom-number-input__qty-btn--add");
				var $remBtn = input.siblings(".custom-number-input__qty-btn--rem");

				if (min !== undefined && value <= min) {
					$remBtn.addClass("disabled");
				} else {
					$remBtn.removeClass("disabled");
				}

				if (max !== undefined && value >= max) {
					$addBtn.addClass("disabled");
				} else {
					$addBtn.removeClass("disabled");
				}
			}

			// Initial button state update
			updateButtonStates();
		});
	};
})(jQuery);
